export default __webpack_public_path__ + "static/media/Life_Insurance.c7faaa83.svg";